import React, { useContext } from 'react';
import { Text } from '@fluentui/react';
import { ThemeContext } from '../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../Common/util/localStorageUtils';
import { EnvironmentDataChannel, Pipeline, Region, WorkLane } from '../models/EnvironmentModels';

interface ActiveChannelCardProps {
    channel: EnvironmentDataChannel;
}

export const ActiveChannelCard: React.FC<ActiveChannelCardProps> = ({ channel }) => {
const themeContext = useContext(ThemeContext);
const theme = getThemeFromString(themeContext.themeName);

    return (
        <div
            style={{
                padding: '12px',
                backgroundColor: theme.palette.white,
                border: `1px solid ${theme.palette.neutralLight}`,
                borderLeft: channel.isActive
                    ? `4px solid ${theme.palette.green}`
                    : `4px solid ${theme.palette.neutralTertiary}`,
                boxShadow: theme.effects.elevation4,
                borderRadius: '4px',
            }}
        >
            <Text variant="medium" styles={{ root: { fontWeight: 600, marginBottom: '8px' } }}>
                {channel.name}
            </Text>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <Text variant="small">
                    <strong>Pipeline:</strong> {Pipeline[channel.pipeline]}
                </Text>
                <Text variant="small">
                    <strong>Region:</strong> {Region[channel.region]}
                </Text>
                <Text variant="small">
                    <strong>Work Lane:</strong> {WorkLane[channel.workLane]}
                </Text>
                <Text variant="small">
                    <strong>Status:</strong>{' '}
                    <span style={{ color: channel.isActive ? theme.palette.green : theme.palette.neutralSecondary }}>
                        {channel.isActive ? 'Active' : 'Inactive'}
                    </span>
                </Text>
            </div>
        </div>
    );
};
